import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { PaymentMethod } from "../../models/payment-method.model";

export namespace PaymentMethodActions {

  @logDispatcher
  export class GetPaymentMethods {
    static readonly type = '[PaymentMethod] GetPaymentMethods';
    constructor() { }
  }

  @logDispatcher
  export class GetPaymentMethodsSuccess {
    static readonly type = '[PaymentMethod] GetPaymentMethodsSuccess';
    constructor(public paymentMethods: PaymentMethod[]) { }
  }

  @logDispatcher
  export class GetPaymentMethodsFail {
    static readonly type = '[PaymentMethod] GetPaymentMethodsFail';
    constructor(public error: any) { }
  }
}
